import type { ProjectFileResponseDto } from '@inference.engine/workspace-api-client/web';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PROJECTS_QUERY_KEYS } from '@/entities/project';
import { updateProjectFile } from './project-files.api';

interface UseRenameProjectFileOptions {
  projectId: string;
}

interface RenameVariables {
  fileId: string;
  fileName: string;
}

export function useRenameProjectFile(options: UseRenameProjectFileOptions) {
  const queryClient = useQueryClient();
  const { projectId } = options;

  return useMutation<ProjectFileResponseDto, Error, RenameVariables>({
    mutationFn: ({ fileId, fileName }) => updateProjectFile(projectId, fileId, { fileName }),
    onSuccess: (_file, { fileId }) => {
      void queryClient.invalidateQueries({
        queryKey: PROJECTS_QUERY_KEYS.files.detail(projectId, fileId),
      });
      void queryClient.invalidateQueries({ queryKey: ['project', projectId, 'folders'] });
    },
  });
}
